import Modal from './Modal';
import { withTranslation } from 'react-i18next';
import delete_img from "../../webroot/images/alert.svg";

const ConfirmationModal = (props) => {

    const submitResponse = (response) => {
        props.confirmationModalResponse({ response, type: props.confirmationData.type });
    }

    const hideModalReplicate = () => {
        props.confirmationModalResponse({ response: false, type: props.confirmationData.type });
     }

    let { show, confirmationText = '' } = props.confirmationData;

    return (
        <div className="delete-incentive-popup model-popup-outer">
            <Modal show={show} handleClose={hideModalReplicate}>
                <div className="modal-header"></div>
                <div className="modal-body">
                    <div className="delete-popup-txt">
                        <img src={delete_img} className="" alt="" />
                        <span>{confirmationText}</span>
                        <div className="yes-no-btn">
                            <button className="btn-line" onClick={() => submitResponse(false)} >
                                No
                            </button>
                            <button className="btn-primary" onClick={() => submitResponse(true)}>
                                yes
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default withTranslation('common')(ConfirmationModal);
